import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { OperatorTypesUi } from 'src/app/configs/operator-type-ui.config';
import { PollParserInboxesStatisticsDto } from 'src/app/core/api/models';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { DoughnutChartModule } from "../../../../../../shared/components/charts/doughnut-chart/doughnut-chart.module";

@Component({
    selector: 'app-parser-stats-doughnut-chart',
    templateUrl: './parser-stats-doughnut-chart.component.html',
    styleUrls: ['./parser-stats-doughnut-chart.component.scss'],
    imports: [BaseFormModule, DoughnutChartModule]
})
export class ParserStatsDoughnutChartComponent implements OnInit {

  public chart: any;

  @Input() model: PollParserInboxesStatisticsDto;
  @Input() chartId: string = '';

  labels: string[] = [];
  colors: string[] = [];
  data: number[] = [];
  title: string = this.translateService.instant('pages.pollParsers.stats.doughnutChartTitle');

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    //this.createChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes["model"])) {
      if (this.model.totalAnswerCount> 0) {
        this.setData();
    //  this.createChart();
      }
    }
  }

  setData() {
    let labels2 = [];
    let colors2 = [];
    let data2 = [];

    this.model.items.forEach((item,i) => {
      data2.push(item.count);
      labels2.push(item.smsText);
      colors2.push(OperatorTypesUi[i].color);
    });
    this.labels = labels2;
    this.colors = colors2;
    this.data = data2;
  }

}
